<template>
  <div v-if="display">
    <!-- <div style="position:fixed; width: 5px; height: 5px; background-color: pink; top: 10px; left: 10px"></div> -->
    <loader />

    <div class="container content admin-body">
      <!--<slot :updateMenuActions="updateMenuActions.bind(this, 'buttonText', 'func')" />-->
      <!--<slot :updateMenuActions="() => alert('asdf')" />-->
      <slot />
    </div>

    <bottom-menu>
      <!--
      <template slot-scope="actions">
        <p>{{ actions.text }}</p>
      </template>
      -->
    </bottom-menu>
    <dev-toggle />
    <!-- <slideout-panel /> -->
  </div>
</template>

<script>

import TopNav from '@/components/nav/TopNav'
import BottomMenu from '@/components/nav/BottomMenu'
import DevToggle from '@/components/actions/DevToggle'
import Loader from '@/components/actions/Loader'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    TopNav,
    BottomMenu,
    Loader,
    DevToggle
  },
  data () {
    return {
      isElectron: Boolean,
      display: false
    }
  },
  computed: {
    ...mapState('auth', ['user', 'status'])
  },
  methods: {
    ...mapActions('dev', ['load']),
    ...mapActions('auth', ['logout']),
    ...mapActions('userSettings', ['getCurrentUserSettings']),
    ...mapActions('meta', ['getCountries'])
  },
  created () {
    this.load() // Load dev mode from local storage
    var promises = []
    promises.push(this.getCurrentUserSettings().then(userSettings => {
      let htmlElement = document.getElementById('html')
      htmlElement.style.fontSize = userSettings.fontSize + 'px'

      // Add class to body if client is electron so we can style some stuff differently, and add a back button
      this.isElectron = window.isElectron()

      if (this.isElectron) {
        document.body.classList.add('is-electron')
      }
    }))

    promises.push(this.getCountries())

    Promise.all(promises).then(() => {
      this.display = true
    })
    // setFontSizeFromLocalStorage()
  }
}
</script>

<style lang="scss">
  body {
    padding-bottom: 80px;
  }
</style>



// WEBPACK FOOTER //
// src/components/layouts/AdminLayout.vue